"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWidgetCliSocket = exports.WidgetCliSocketType = void 0;
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const SOCKET_PATH_DEFAULT = 'widget-cli:sockjs-node';
var WidgetCliSocketType;
(function (WidgetCliSocketType) {
    WidgetCliSocketType["LiveReload"] = "liveReload";
})(WidgetCliSocketType = exports.WidgetCliSocketType || (exports.WidgetCliSocketType = {}));
class WidgetCliSocket {
    constructor(origin, _type) {
        this.eventMap = new Map();
        this.socket = (0, socket_io_client_1.default)(origin, { path: `/${SOCKET_PATH_DEFAULT}` }); // Establishing links
        this.socket.loading = true;
        this.socket.on(SOCKET_PATH_DEFAULT, (res) => {
            var _a;
            (_a = this.eventMap.get(res.type)) === null || _a === void 0 ? void 0 : _a.forEach((cb) => cb({
                success: true,
                data: res === null || res === void 0 ? void 0 : res.data
            }));
        });
        // connection successful
        this.socket.on('connect', () => {
            this.socket.loading = false;
        });
        // connection failure
        this.socket.on('disconnect', () => {
            [...this.eventMap.values()].flat(1).forEach((cb) => cb({
                success: false,
                error: 'disconnect'
            }));
        });
    }
    on(type, cb) {
        var _a, _b;
        this.eventMap.has(type) ? (_b = (_a = this.eventMap.get(type)) === null || _a === void 0 ? void 0 : _a.push) === null || _b === void 0 ? void 0 : _b.call(_a, cb) : this.eventMap.set(type, [cb]);
    }
    destroy(type, cb) {
        if (!type) {
            this.socket.disconnect();
        }
        else {
            const events = this.eventMap.get(type) || [];
            events.forEach((v, index) => {
                v === cb && events.splice(index, 1);
            });
        }
        widgetCliSOcket = undefined;
    }
}
let widgetCliSOcket;
const initWidgetCliSocket = (origin, type) => {
    if (!widgetCliSOcket) {
        widgetCliSOcket = new WidgetCliSocket(origin, type);
    }
    return widgetCliSOcket;
};
exports.initWidgetCliSocket = initWidgetCliSocket;
